import React from "react";

const ThaiMassageSpaWellness = () => {
  return (
    <div className="headSpaHeadContainer">
      <h2>Thai Massage in Bangalore - A Healing Tradition at SCENT</h2>
      <p>
        At SCENT, Thai massage is part of a broader approach to holistic
        wellness. The salon offers a comprehensive range of treatments,
        including <a href="https://scentlifestyle.com/aroma-massage-in-bangalore">aromatherapy</a>, <a href="https://scentlifestyle.com/thai-reflexology-massage-in-bangalore">Thai Reflexology</a>,
        and <a href="https://scentlifestyle.com/spa">spa therapies</a>, all designed to promote overall
        well-being. This holistic approach ensures that clients can enjoy a
        complete wellness experience that addresses both physical and mental
        health.
      </p>
    </div>
  );
};

export default ThaiMassageSpaWellness;
